import APIURL from "../axios";
import { useQuery } from "react-query";

export const getCarCompaniesAPI = async ({ room_uuid, lang }) => {
  return await APIURL.get(`/${room_uuid}/car-rental/companies`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang,
    },
  });
};

export const CarsAPI = async ({
  room_uuid,
  car_company_uuid,
  car_type_id,
  car_model_id,
  car_year_id,
  sort_direction,
  lang,
}) => {
  const params = new URLSearchParams();

  if (car_type_id) params.append("car_type_id", car_type_id);
  if (car_model_id) params.append("car_model_id", car_model_id);
  if (car_year_id) params.append("car_year_id", car_year_id);

  if (sort_direction) {
    params.append("sort_direction", sort_direction);
    params.append("sort_by", "price");
  }

  return await APIURL.get(
    `/${room_uuid}/car-rental/company/${car_company_uuid}/cars?${params.toString()}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang,
      },
    }
  );
};

export const getCarTypesAPI = async ({ room_uuid, car_company_uuid, lang }) => {
  return await APIURL.get(
    `/${room_uuid}/car-rental/company/${car_company_uuid}/types`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang,
      },
    }
  );
};

export const getCarModelsAPI = async ({
  room_uuid,
  car_company_uuid,
  car_rental_type_id,
  lang,
}) => {
  return await APIURL.get(
    `/${room_uuid}/car-rental/company/${car_company_uuid}/models`,
    {
      params: {
        car_rental_type_id,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang,
      },
    }
  );
};

export const getCarYearsAPI = async ({ room_uuid, car_company_uuid, lang }) => {
  return await APIURL.get(
    `/${room_uuid}/car-rental/company/${car_company_uuid}/years`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        lang,
      },
    }
  );
};
